module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAAGXcA1uAAAAAXNSR0IArs4c6QAAALRJREFUSA3tUtsNwzAIxFEGqDpH9upXBskIWbIrNKYS6Ix0sulXIzmSw2EeB5jyecsmIns9IlU5v6D+FgMqC1pG3SDBarg85WVYZcOChpYRLDSiKQsCOAdNRQ20KuRD7I3rZWweHQ1TanOI8g8DdEpHrfMRa2W69jDsrEnSTfs7jLzBTwzpkmaAzrn3pXeplzDa07sXE/R0Xz10HF1DjGE4vUgsEbufBGwyfj9H5KNg4P4jugC+rRuarVW8fQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/lt.png
// module id = S1Im
// module chunks = 0